import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { MatchParam } from "src/constants/matches";
import Message from "src/components/Messaging/components/MessagesList/components/Message";
import NewMessageForm from "src/components/Messaging/components/MessagesList/components/NewMessageForm";
import { useMessages } from "src/context/MessagesProvider";
import { useRef, useEffect } from "react";
import ExpandedView from "src/components/ExpandedView";

const Messaging = () => {
  const { thread } = useParams<MatchParam<"THREAD_ID">>();

  const bottomRef = useRef<HTMLDivElement>(null);
  const messages = useMessages();

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <ExpandedView
      sx={{
        boxShadow: "0px 3px 13px 0px rgba(0, 0, 0, 0.05)",
      }}
      padding="16px"
      borderRadius="10px"
      data-testid="desktop-message-thread"
    >
      <Box
        sx={{ flex: 1, overflowY: "auto", mt: 2, mb: 2 }}
        role="list"
        aria-label="Messages"
      >
        {messages.map((message) => (
          <Message message={message} key={message.public_id} />
        ))}
        <div ref={bottomRef} />
      </Box>
      {thread ? <NewMessageForm threadSlug={thread} /> : null}
    </ExpandedView>
  );
};

export default Messaging;
